module.exports = __webpack_public_path__ + "img/device_1001_3_select.97a6fd58.svg";